import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-1 w-6 rounded-full bg-primary-500"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}